import { parseOperatingMetricInputValue } from "./Detail/OperatingTime/helper";
import { WorkOrderAutoSaveFieldKey, WorkOrderDetail } from "./types";

/**
 * Applies an auto-save field value onto work order detail state.
 */
export const applyWorkOrderDataByKey = (
    data: WorkOrderDetail,
    key: WorkOrderAutoSaveFieldKey,
    value: string,
): void => {
    switch (key) {
        case 'operatingTime':
            data.operatingTime = parseOperatingMetricInputValue(value);
            break;
        case 'operatingCount':
            data.operatingCount = parseOperatingMetricInputValue(value);
            break;
        case 'comment':
            data.comment = value;
            break;
        case 'description':
            data.description = value;
            break;
        case 'scheduledStartDate':
            data.scheduledStartDate = value;
            break;
        case 'scheduledEndDate':
            data.scheduledEndDate = value;
            break;
    }
};

export const ATTACHMENT_MAX_FILES = 5;

export const ATTACHMENT_MAX_FILE_SIZE = 50; // MB
